import React from "react";
import HeroSection from "./_HeroSection";
import AccentSection from "./_AccentSection";
import FormSection from "./_FormSection";
import StatusSection from "./_StatusSection";
import PageTitleScript from "@/components/MetaScript";
import BackgroundBorderSection from "./_BackgroundBorderSection";
import TextSection from "./_TextSection";

const BrandThemePage: React.FC = () => {
  return (
    <div className="w-full flex flex-col bg-white">
      <PageTitleScript title="Brand Theme" />
      <HeroSection />

      <TextSection />
      <FormSection />
      <BackgroundBorderSection />

      <AccentSection />
      <StatusSection />
    </div>
  );
};

export default BrandThemePage;
